//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/error.proto.
 */
export const file_dxos_error = /*@__PURE__*/ fileDesc("ChBkeG9zL2Vycm9yLnByb3RvEgpkeG9zLmVycm9yIp4BCgVFcnJvchIRCgRuYW1lGAEgASgJSACIAQESFAoHbWVzc2FnZRgCIAEoCUgBiAEBEi0KB2NvbnRleHQYBCABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0SAKIAQESEgoFc3RhY2sYAyABKAlIA4gBAUIHCgVfbmFtZUIKCghfbWVzc2FnZUIKCghfY29udGV4dEIICgZfc3RhY2tCK1opZ2l0aHViLmNvbS9keG9zL2R4b3MvcHJvdG8vZGVmL2R4b3MvZXJyb3JiBnByb3RvMw", [file_google_protobuf_struct]);
/**
 * Describes the message dxos.error.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema = /*@__PURE__*/ messageDesc(file_dxos_error, 0);
//# sourceMappingURL=error_pb.js.map